import { useEffect, useRef, useState } from 'react';
import { populateCredentialViewData } from './utils/credential';

function useCredential(credentialID: string) {
  const [credentialData, setCredentialData] = useState([]);
  const [credentialDataLoaded, setCredentialDataLoaded] = useState(false);
  const hasFetchedData = useRef(false);

  useEffect(() => {
    populateCredentialViewData(credentialID, credentialCallback);
  }, []);

  const credentialCallback = (data) => {
    if (!hasFetchedData.current) {
      setCredentialData(data);
      setCredentialDataLoaded(true);
      hasFetchedData.current = true;
    }
  };

  return [credentialData as any, credentialDataLoaded];
}

export { useCredential };
